import { gate } from 'hub-http/gates';
export const SPRING_SPOTLIGHT_GATE = gate('MultiAccountManagement:SpringSpotlight');